import Oge from './index'
const ApplicationCenter = () => {
	return <Oge id="applicationCenter" url="applicationCenter" type="null" />
}
export default ApplicationCenter;